type TDetail<T, K extends string> = { description: string } & { [key in K]: T };
/**
 * @dispatchCustomEvent
 * @param eventTarget html элемент
 * @param eventName название события
 * @param detail объект для передачи в событии
 * @return void
 */
export function dispatchCustomEvent<T, K extends string>(
  eventTarget: EventTarget,
  eventName: string,
  detail: TDetail<T, K>,
): void {
  eventTarget.dispatchEvent(
    new CustomEvent(eventName, {
      bubbles: true,
      cancelable: false,
      detail,
    }),
  );
}
